import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup, Glyphicon } from "react-bootstrap";
import DividerLine from "src/components/common/DividerLine";
import LoadingStatus from "src/components/common/LoadingStatus";
import { IBaseState } from "src/interfaces";
import { ICarryForwardCreditsProps } from "./interfaces";

export default class CarryForwardCredits extends Component<ICarryForwardCreditsProps, IBaseState> {
  public constructor(props: ICarryForwardCreditsProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset>
          <legend>Carry Forward Credits</legend>
          <LoadingStatus singular={true} width={25} height={25} />
        </fieldset>
      );
    }

    const xsLabelWidthR = 6;
    const xsInputWidthR = 6;
    const smLabelWidthR = 6;
    const smInputWidthR = 6;
    const mdLabelWidthR = 6;
    const mdInputWidthR = 6;

    return (
      <fieldset className="fieldset-right">
        <legend>Carry Forward Credits</legend>
        <FormGroup bsSize="small" controlId="solarReceived">
          <Col xs={xsLabelWidthR} sm={smLabelWidthR} md={mdLabelWidthR}>
            Solar Received
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.solarReceived}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="lastMonthsCredits">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            <Glyphicon glyph="glyphicon glyphicon-plus" /> Credits
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.credits}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="gridUsage">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            <Glyphicon glyph="glyphicon glyphicon-minus" /> Grid Usage
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.gridUsage}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthR}
          xs={xsInputWidthR}
          smOffset={smLabelWidthR}
          sm={smInputWidthR}
          mdOffset={mdLabelWidthR}
          md={mdInputWidthR}
        />
        <FormGroup bsSize="small" controlId="creditBalance">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Credit Balance
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.creditBalance}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/singlerate/CarryForwardCredits.tsx